const SvgIcon = (props) => (
    <svg
        enableBackground='new 0 0 60 60'
        style={ props.style }
        viewBox='0 0 60 60'
        xmlSpace='preserve'
        { ...props }>
        { props.children }
    </svg>
);


export default SvgIcon;



// WEBPACK FOOTER //
// ./src/common/components/svg-icon/index.js